const REPORT_DATE_PRESETS = [
  { text: "Month", value: "month" },
  { text: "Quarter", value: "quarter" },
  { text: "Bi-Annual", value: "bi-annual" },
  { text: "Yearly", value: "yearly" },
];

const pad = (value) => String(value).padStart(2, "0");

const getCurrentYear = () => new Date().getFullYear();

const buildYearOptions = (currentYear, pastYears = 10, futureYears = 1) => {
  const years = [];
  for (let year = currentYear + futureYears; year >= currentYear - pastYears; year -= 1) {
    years.push(year);
  }
  return years;
};

const buildPeriodOptions = (preset) => {
  if (!preset || preset === "yearly") return [];
  const ranges = {
    month: 12,
    quarter: 4,
    "bi-annual": 2,
  };
  const count = ranges[preset];
  if (!count) return [];
  return Array.from({ length: count }, (_, index) => {
    const value = index + 1;
    return { text: String(value), value };
  });
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  return `${year}-${month}-${day}`;
};

const getDefaultPeriod = (preset, referenceDate = new Date()) => {
  const month = referenceDate.getMonth();
  if (preset === "month") return month + 1;
  if (preset === "quarter") return Math.floor(month / 3) + 1;
  if (preset === "bi-annual") return month < 6 ? 1 : 2;
  return null;
};

const normalizePeriod = (preset, period, referenceDate) => {
  const defaultPeriod = getDefaultPeriod(preset, referenceDate);
  const parsed = Number(period);
  if (!Number.isFinite(parsed)) return defaultPeriod;
  if (preset === "month" && parsed >= 1 && parsed <= 12) return parsed;
  if (preset === "quarter" && parsed >= 1 && parsed <= 4) return parsed;
  if (preset === "bi-annual" && parsed >= 1 && parsed <= 2) return parsed;
  if (preset === "yearly") return null;
  return defaultPeriod;
};

const getPresetRange = (preset, options = {}) => {
  const referenceDate = options.referenceDate || new Date();
  if (!preset) return null;

  const year = Number.isFinite(Number(options.year))
    ? Number(options.year)
    : referenceDate.getFullYear();
  const month = referenceDate.getMonth();
  const period = normalizePeriod(preset, options.period, referenceDate);
  let start;
  let end;

  switch (preset) {
    case "month": {
      const targetMonth = period ? period - 1 : month;
      start = new Date(year, targetMonth, 1);
      end = new Date(year, targetMonth + 1, 0);
      break;
    }
    case "quarter": {
      const quarterIndex = period ? period - 1 : Math.floor(month / 3);
      const quarterStartMonth = quarterIndex * 3;
      start = new Date(year, quarterStartMonth, 1);
      end = new Date(year, quarterStartMonth + 3, 0);
      break;
    }
    case "bi-annual": {
      const isFirstHalf = period ? period === 1 : month < 6;
      start = new Date(year, isFirstHalf ? 0 : 6, 1);
      end = new Date(year, isFirstHalf ? 6 : 12, 0);
      break;
    }
    case "yearly": {
      start = new Date(year, 0, 1);
      end = new Date(year, 12, 0);
      break;
    }
    default:
      return null;
  }

  return {
    startDate: formatDate(start),
    endDate: formatDate(end),
  };
};

export default {
  data() {
    const currentYear = getCurrentYear();
    return {
      dateRangePresets: REPORT_DATE_PRESETS,
      dateRangeYears: buildYearOptions(currentYear),
    };
  },
  methods: {
    getPresetPeriodOptions(preset) {
      return buildPeriodOptions(preset);
    },
    getDefaultPresetYear() {
      return getCurrentYear();
    },
    getDefaultPresetPeriod(preset) {
      return getDefaultPeriod(preset);
    },
    applyDatePreset(preset, startField, endField, options = {}) {
      const range = getPresetRange(preset, options);
      if (!range) return;
      if (startField) this[startField] = range.startDate;
      if (endField) this[endField] = range.endDate;
    },
    applyPresetWithSelection(preset, startField, endField, yearField, periodField) {
      if (!preset) return;
      const yearValue = yearField ? this[yearField] : null;
      const periodValue = periodField ? this[periodField] : null;
      const nextYear = yearValue || this.getDefaultPresetYear();
      const nextPeriod = preset === "yearly" ? null : (periodValue || this.getDefaultPresetPeriod(preset));
      if (yearField && !yearValue) this[yearField] = nextYear;
      if (periodField && preset !== "yearly" && !periodValue) this[periodField] = nextPeriod;
      this.applyDatePreset(preset, startField, endField, {
        year: nextYear,
        period: nextPeriod,
      });
    },
  },
};
